import React from 'react';
import { Skeleton } from 'antd';
import './style.scss';

const NUMBER_OF_BLOCKS = [1, 1, 1, 1, 1, 1, 1, 1];

export interface IActivitySkeletonContentProps {
  label: string;
  isTitle?: boolean;
}

export const ActivitySkeletonContent: React.FC<IActivitySkeletonContentProps> = ({ label: _label, isTitle: _isTitle = true }) => {
  return (
    <div className="activity-skeleton-content">
      <div className="activity-skeleton-content__grid">
        {NUMBER_OF_BLOCKS.map((item, index) => (
          <div
            key={`${index}-${item}`}
            className="activity-skeleton-content__card"
          >
            <div className="activity-skeleton-content__img-wrapper">
              <Skeleton.Button
                active
                block
                className="activity-skeleton-content__img-button"
              />
            </div>

            <div className="activity-skeleton-content__info-wrapper">
              <div className="activity-skeleton-content__top-info">
                <Skeleton active title={{ width: '30%' }} paragraph={false} />
              </div>

              <Skeleton active title={{ width: '100%' }} paragraph={{ rows: 1, width: '80%' }} className="activity-skeleton-content__title" />

              <div className="activity-skeleton-content__details">
                <Skeleton active title={{ width: '60%' }} paragraph={false} />
                <Skeleton active title={{ width: '40%' }} paragraph={false} />
              </div>

              <div className="activity-skeleton-content__footer">
                <div className="activity-skeleton-content__left-footer">
                  <Skeleton active title={{ width: '40%' }} paragraph={false} />
                </div>
                <div className="activity-skeleton-content__price">
                  <Skeleton active title={{ width: '80%' }} paragraph={false} className="price-bold" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
